import { Button, Menu, MenuItem } from '@mui/material';
import { useState, type MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthorization } from '@/authorization';
import { productBulkActionDefinitions } from '@/config/productRegistry';

interface BulkActionsToolbarProps {
  selectedCount: number;
  onAction?: (actionId: string) => void;
}

export function BulkActionsToolbar({
  selectedCount,
  onAction,
}: BulkActionsToolbarProps) {
  const { t } = useTranslation('entity-portal');
  const { hasPermission } = useAuthorization();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const visibleActions = productBulkActionDefinitions.filter((action) => {
    if (!action.permission) {
      return true;
    }

    return hasPermission(action.permission);
  });

  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (actionId: string) => {
    onAction?.(actionId);
    handleClose();
  };

  return (
    <>
      <Button
        variant="outlined"
        size="medium"
        disabled={selectedCount === 0}
        aria-label={t('productRegistry.productRegistryBulkOperations')}
        onClick={handleOpen}
      >
        {t('productRegistry.productRegistryBulkOperationsCount', { count: selectedCount })}
      </Button>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {visibleActions.map((action) => (
          <MenuItem key={action.id} onClick={() => handleSelect(action.id)}>
            {t(action.labelKey)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
